module.exports = __webpack_public_path__ + "static/media/register_bg.e898427e.png";